<template>
	<div class="content-sections">
		<section class="stack">
			<h4 class="sgnl-h6-semibold sgnl-text-color-default">Generate a new API key</h4>
			<!-- <v-divider></v-divider> -->
			<GenerateAPIKey @keyCreated="handleNewAPIKeyCreated" />
		</section>
		<section class="stack">
			<div class="section-title section-title--baseline">
				<h4 class="sgnl-h6-semibold sgnl-text-color-default sgnl-m-0">Current API keys</h4>
				<QuotaCount
					:used="keyCount"
					limit-id="KeyCount"
				/>
			</div>
			<ListAPIKeys
				ref="listAPIKeysComponent"
				@count-changed="keyCount = $event"
			/>
			<!-- <v-divider></v-divider> -->
		</section>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Types
import { AWSAuthenticatedUserObject } from "@/types/user";

// Components
import GenerateAPIKey from "@/components/Settings/ComputeEngineApi/GenerateAPIKey.vue";
import ListAPIKeys from "@/components/Settings/ComputeEngineApi/ListAPIKeys.vue";
import QuotaCount from "@/components/Common/QuotaCount.vue";

// Stores
import { useUserStore } from "@/stores/user";

type ComponentData = {
	deleteAccountDialog: boolean;
	authenticatedUser: undefined | null | AWSAuthenticatedUserObject;
	keyCount: number;
};

export default defineComponent({
	name: "SettingscloudEngineAPI",
	props: {},
	components: {
		GenerateAPIKey,
		ListAPIKeys,
		QuotaCount,
	},
	data: (): ComponentData => ({
		deleteAccountDialog: false,
		authenticatedUser: undefined,
		keyCount: 0,
	}),
	setup() {
		const userStore = useUserStore();
		return { userStore };
	},
	methods: {
		handleNewAPIKeyCreated() {
			this.$refs.listAPIKeysComponent!["refreshList"]();
		},
	},
	async created() {
		const authUser = await this.userStore.getCurrentAuthenticatedUserObject();
		this.authenticatedUser = authUser;
	},
});
</script>
